import React from 'react';

import PropTypes from 'prop-types';

import ProgressRing from '@adsk/alloy-react-progress-ring';

import EntityPickerModalEmptyState from './EntityPickerModalEmptyState';
import EntityPickerModalError from './EntityPickerModalError';
import EntityPickerModalNoSearchResults from './EntityPickerModalNoSearchResults';
import { pluginShape } from '../helpers/propTypes';

const DefaultLoader = () => <ProgressRing size={ProgressRing.SIZES.MEDIUM} />;

const EntityPickerModalNoData = ({
  plugin,
  loading,
  error,
  onTryAgain,
  filters,
  setFilters,
  canCreate,
  onCreateClick,
  dataViewProps,
}) => {
  if (loading) {
    const Loader = plugin.CustomPickerEmptyLoader || DefaultLoader;
    return <Loader />;
  }
  if (error) {
    const Error = plugin.CustomPickerError || EntityPickerModalError;
    return (
      <Error
        error={error}
        onTryAgain={onTryAgain}
        dataViewProps={dataViewProps}
      />
    );
  }
  if (filters && Object.keys(filters).length) {
    const NoResults =
      plugin.CustomPickerNoSearchResults || EntityPickerModalNoSearchResults;
    return (
      <NoResults
        clearFilters={() => setFilters({})}
        setFilters={setFilters}
        filters={filters}
        dataViewProps={dataViewProps}
      />
    );
  }
  const NoData = plugin.CustomPickerEmptyState || EntityPickerModalEmptyState;
  return (
    <NoData
      onCreateClick={onCreateClick}
      canCreate={canCreate}
      plugin={plugin}
      dataViewProps={dataViewProps}
    />
  );
};

EntityPickerModalNoData.propTypes = {
  /**
   * The plugin to use for selected entity type.
   */
  plugin: pluginShape.isRequired,
  /**
   * Whether we're loading something from BE.
   */
  loading: PropTypes.bool,
  /**
   * Whether had error fetching data from BE. error is an object when has error thrown by BE
   */
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  /**
   * Callback to fetch data again.
   */
  onTryAgain: PropTypes.func,
  /**
   * The currently applied filters.
   */
  filters: PropTypes.object,
  /**
   * Callback to set filters.
   */
  setFilters: PropTypes.func,
  /**
   * Whether the user can create entity of selected type.
   */
  canCreate: PropTypes.bool.isRequired,
  /**
   * Callback when clicking create button
   */
  onCreateClick: PropTypes.func.isRequired,
  /**
   * Additional props to pass to DataView.
   */
  dataViewProps: PropTypes.object,
};

export default EntityPickerModalNoData;
